module.exports = __webpack_public_path__ + "static/media/1080p.f767eb9.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/1080p.mp4
// module id = WFI7
// module chunks = 43